//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { AccesoriosInterface } from "../../../../interfaces/AccesoriosInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./AccesoriosTable.module.css").default;

const AccesoriosTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [accesorios, setAccesorios] = useState<AccesoriosInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los accesorios traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setAccesorios(variable.data);
  }, []);

  //Función que llama todos los accesorios paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/accesorio",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un accesorios.
  const changeAccesorioStatus = useCallback(
    (idAccesorio: number) => {
      if (
        window.confirm("¿Seguro que desea cambiar el estatus del accesorio?")
      ) {
        sendRequest(
          {
            url: `/accesorio/${idAccesorio}`,
            method: "DELETE",
          },
          (variable: any) => {
            setAccesorios([]);
            toast.success("El accesorio ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/accesorio",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<AccesoriosInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar accesorio"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/accesorios/edit/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("Accesorio:update")}
            >
              <FontAwesomeIcon icon={faPen} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar accesorio"
                  : "Habilitar accesorio"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("Accesorio:delete")}
              onClick={() => changeAccesorioStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={info.row.original.estatus ? faToggleOn : faToggleOff}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changeAccesorioStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!accesorios) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de accesorios</h2>
      {/** Botón para agregar usuario */}
      {authContext.tokenCan("Accesorio:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar un nuevo accesorio"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/accesorios/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus} /> Nuevo accesorio
          </Button>
        </div>
      )}

      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: accesorios,
          columns,
        }}
      />
    </Container>
  );
};

export default AccesoriosTable;
